let loadingInstance = null;

const defaultOptions = {
  lock: true,
  text: "加载中...",
  spinner: "el-icon-loading",
  background: "rgba(255, 255, 255, 0.7)",
  fullScreen: true
};

/**
 * 显示全局 loading
 * @param {Object} options - 自定义配置
 */
export function showLoading(options = {}) {
  if (!loadingInstance) {
    loadingInstance = this.$loading({
      ...defaultOptions,
      ...options
    });
  }
}

/**
 * 隐藏全局 loading
 */
export function hideLoading() {
  if (loadingInstance) {
    loadingInstance.close();
    loadingInstance = null;
  }
}
